import {HoistModel, LoadSpec, managed} from '@xh/hoist/core';
import {PositionsModel} from './impl/positions/PositionsModel';
import {WatchlistPanelModel} from './impl/watchlist/WatchlistPanelModel';
import {PortfolioModel} from './impl/portfolio/PortfolioModel';
import {WorkingOrdersModel} from './impl/orders/WorkingOrdersModel';

export class PortfolioTabModel extends HoistModel {
    @managed portfolioModel = new PortfolioModel();
    @managed positionsModel = new PositionsModel();
    @managed watchlistModel = new WatchlistPanelModel();
    @managed workingOrdersModel = new WorkingOrdersModel();

    constructor() {
        super();

        this.addReaction({
            track: () => this.portfolioModel.portfolioId,
            run: portfolioId => {
                this.positionsModel.setPortfolio(portfolioId);
                this.workingOrdersModel.setPortfolio(portfolioId);
            },
            fireImmediately: true
        });
    }

    override async doLoadAsync(loadSpec: LoadSpec): Promise<void> {
        await this.portfolioModel.doLoadAsync(loadSpec);
        await this.positionsModel.doLoadAsync(loadSpec);
        await this.watchlistModel.doLoadAsync(loadSpec);
        await this.workingOrdersModel.doLoadAsync(loadSpec);
    }
}
